import DisplayItemsToggle from 'views/atoms/DisplayItemsToggle/DisplayItemsToggle';

export default DisplayItemsToggle;
